import React from 'react';
import {
  HStack,
  Button,
  ButtonText,
  Progress,
  ProgressFilledTrack,
  Spinner,
} from '@gluestack-ui/themed';
import { useUserFeatures } from '../../../common/hooks/useUserFeatures';
import { useDialog } from '../../../common/context/DialogContext';

const AutogradeControl = ({
  show,
  variant = 'primary',
  isJobRunning = false,
  progress = 0,
  onRequestAutograde,
}) => {
  const { isFeatureActive } = useUserFeatures();
  const taskAiEnabled = isFeatureActive('lecturer-task-ai');
  const { showDialog } = useDialog();

  const handleAutograde = () => {
    showDialog({
      title: 'AutoGrade',
      message:
        'Are you sure, you want to start the AutoGrading process? This will overwrite all existing comments and scores for this submission.',
      buttons: [
        { text: 'Cancel', variant: 'outline', action: 'secondary' },
        {
          text: 'Autograde',
          onPress: onRequestAutograde,
        },
      ],
    });
  };

  if (!show || !taskAiEnabled) {
    return null;
  }

  if (!isJobRunning) {
    return (
      <Button size="sm" action={variant} onPress={handleAutograde}>
        <ButtonText>AutoGrade</ButtonText>
      </Button>
    );
  }

  return (
    <HStack w={200} space="lg" alignItems="center">
      <Progress flex={1} value={progress} size="sm">
        <ProgressFilledTrack />
      </Progress>
      <Spinner />
    </HStack>
  );
};

export default AutogradeControl;
